"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = QuickLinks;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _link = _interopRequireDefault(require("../../../elements/buttons/link"));
var _text = _interopRequireDefault(require("@ux/text"));
const Wrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Wrapper",
  class: "pl-wa935k8"
});
function QuickLinks({
  quickLinksLabel,
  quickLinks
}) {
  return /*#__PURE__*/_react.default.createElement(Wrapper, {
    "data-cy": "quick-links"
  }, /*#__PURE__*/_react.default.createElement(_text.default.div, {
    as: "label",
    size: 1,
    "data-cy": "label",
    className: "text-uppercase",
    text: quickLinksLabel
  }), /*#__PURE__*/_react.default.createElement("ul", {
    "data-cy": "list"
  }, quickLinks && quickLinks.map(({
    _name,
    ...link
  }, i) => /*#__PURE__*/_react.default.createElement("li", {
    key: i
  }, /*#__PURE__*/_react.default.createElement(_link.default, (0, _extends2.default)({
    _name: `quick_links_${i}.${_name}`
  }, link, {
    isPromo: false
  }))))));
}
QuickLinks.propTypes = {
  quickLinksLabel: _propTypes.default.string,
  quickLinks: _propTypes.default.arrayOf(_propTypes.default.shape(_link.default.propTypes))
};